import { render, staticRenderFns } from "./UpLoadImage.vue?vue&type=template&id=275b592c&scoped=true&"
import script from "./UpLoadImage.vue?vue&type=script&lang=js&"
export * from "./UpLoadImage.vue?vue&type=script&lang=js&"
import style0 from "./UpLoadImage.vue?vue&type=style&index=0&id=275b592c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275b592c",
  null
  
)

export default component.exports